import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMStoppableColumnDef } from "../common/forecastedEOMStoppableColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceUnusedSinceCellRenderer } from "../common/resourceUnusedSinceCellRenderer";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";
import { platformColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/platformColumnDef";
import { resourceTotalCpuColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/resourceTotalCpuColumnDef";
import { getResourceSizeColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceSizeColumnDef";

export const azVmColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Instance Name"),

  forecastedEOMStoppableColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_vm"),
  platformColumnDef,
  resourceAccountColumnDef,

  resourceUnusedSinceCellRenderer,

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "az_vm"),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  resourceTotalCpuColumnDef,

  getResourceSizeColumnDef({
    propName: "total_memory",
    headerName: "Total Memory",
  }),

  { field: "resource.resource_group", headerName: "Resource Group" },

  { field: "resource.size", headerName: "Machine Size" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
